import React, { Component } from 'react';
import ReactEcharts from "echarts-for-react";
import 'echarts/map/js/china';

class China extends Component {

    getOption = () => {

        return {
            xAxis: {
                type: 'category',
                data: this.props.data.xname,
                // nameTextStyle: {
                //     color: '#a5c0de'
                // },
                axisLine: {
                    lineStyle: {
                        color: '#b0fffa'
                    }
                }

            },
            yAxis: {
                type: 'value',
                splitLine: {    //网格线
                    lineStyle: {
                        type: 'dotted',    //设置网格线类型 dotted：虚线   solid:实线
                        color: "#3b7fc3"
                    },
                    show: true //隐藏或显示
                },
                axisLine: {
                    lineStyle: {
                        color: '#b0fffa'
                    }
                }
            },
            series: [{
                data: this.props.data.data,
                type: 'line',
                itemStyle: {
                    normal: {
                        color: '#8cd5c2', //改变折线点的颜色
                        lineStyle: {
                            color: '#b0fffa' //改变折线颜色
                        }
                    }
                }
            }],
            grid: {
                // height:300,
                top: 10,
                bottom: 30,
                left: 50,
                right: 15
            }

        };
    }
    render() {
        return <ReactEcharts
            style={{
                width: '100%',
                height: "100%",
                padding: '5px'
            }}
            option={this.getOption()}
            theme="clear"
        />
    }
}
export default China